import { OfferCompleterComponent } from '../offer-completer/offer-completer.component';
import { Component, OnInit, Input } from '@angular/core';
import { MdDialog, MdDialogRef } from '@angular/material';
import { JobsOffer } from '../../models/jobs-offer';
import { JobOffersService } from '../../services/job-offers.service';
import { Invite } from '../../models/invite';
import { InviteService } from '../../services/invite.service';
import { MessageBoxDialog } from '../message-box/message-box.component';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import {Observable} from "rxjs";
import { MessageBoxInviteDialog } from '../message-box-invite/message-box-invite.component';
import { PaymentDialogComponent } from '../payment-dialog/payment-dialog.component';

@Component({
  selector: 'app-job-selector-dialog',
  templateUrl: './job-selector-dialog.component.html',
  styleUrls: ['./job-selector-dialog.component.css']
})
export class JobSelectorDialogComponent implements OnInit {
  publicating: boolean = false;
  @Input() UserID;
  @Input() JobID;
  @Input() JobName;
  @Input() Jobemail;
  @Input() nameComponent;
  @Input() hv;
  
  createInvite: boolean = true;
  userId: string;
  errorMessage: string;
  offer_id:string;
  jobs:any;
  offername: any;
  jobId: string;
  premium: number;
  loading: boolean;
  job: any;
 

  constructor(public dialogRef: MdDialogRef<JobSelectorDialogComponent>, private dialog: MdDialog, private router: Router, private JobOffersService:JobOffersService, private inviteService: InviteService) {
  }

  ngOnInit() {
    this.loading = true;
    this.userId = this.UserID; 
    if (this.hv==1){
      this.userId = this.UserID.user_id
    }

    let status = [];
    //this.offername = this.JobName;
    // this.jobId = this.JobID;
    if (this.JobID) {
      this.getOfferById(this.JobID);
    }
    
    status.push('1');
    this.premium = 1;
    this.JobOffersService.getOffers(undefined, undefined, status, 1, 1000000, this.premium)
    .subscribe(
      data => {
        this.jobs = data.jobs;
        this.loading = false;
        // this.selectJobId();
      }
    );
  }

  // selectJobId() {
  //   if (this.JobID) {
  //     this.jobId = this.JobID;
  //   }
  // }

  getOfferById(id) {
    this.JobOffersService.getOffersById(id)
    .subscribe(
      data => {
        this.job = data;
        this.loading = false;
        // this.selectJobId();
      }
    );
  }

  getOfferInput($event) {
    this.jobId = $event.id;
    this.offername = $event.title;
    if (this.offername !== null) {
      this.getOfferById(this.jobId);
    } else {
      if (this.JobID !== null) {
        this.getOfferById(this.JobID);
      }
    }
  }

  onInvite () {
    this.onPostInvite();
  }

  onPostInvite() {
    let invitations;
    if (this.jobId) {
      invitations = [{
        "job_id":this.jobId,
        "user_id":this.userId,
        "email":this.Jobemail}];
    } else {
      if (this.JobID !== null) {
        invitations = [{
          "job_id":this.JobID,
          "user_id":this.userId,
          "email":this.Jobemail}];
      }
      
    }
    
    this.inviteService.postInvite(invitations)
      .subscribe(
        data => {
          this.dialogRef.close(data);
          this.dialog.open(MessageBoxInviteDialog, {data: {data: data, success: true, showIcon:true}});
        },
        error => {
          let txterrors : string = error;
          let jsonErrors : any =  [];
          jsonErrors =  JSON.parse(txterrors).errors;
          txterrors = '';
          if (jsonErrors.length > 0){
            jsonErrors.forEach(function(element, index) {
                let err: any;
                let txterr: string = "";
                for(err in element.errors){
                  txterr = txterr+" "+element.errors[err][0];
                }
                txterrors = txterrors+"<p class='bg-danger'>"+txterr+"</p>";

            });
          }else{
                txterrors = "<p class='bg-danger'>no hubo errores</p>"
          }
          this.publicating = false;
          this.errorMessage = <any>error

          this.dialog.open(MessageBoxDialog, {data: {title: 'Información Dreamjobs', html: txterrors, alert: true, showIcon: true}});
        }
      );
  }

  goToOffer(id) {
    this.dialog.closeAll();
    this.router.navigate(['viewinvite/' + id]);
  }

  openDialogPaymentCredits() {
    let dialogRef = this.dialog.open(PaymentDialogComponent);
    // dialogRef.afterClosed().subscribe(result => {
    //   this.searchTransactions();
    // });
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/job-selector-dialog/job-selector-dialog.component.ts